import React from "react";

const Option = ({ name, label, checked, onClick }) => {
  return (
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        id={name}
        name={name}
        value="option2"
        checked={checked}
        onClick={onClick}
      />
      <label className="form-check-label" for={name}>
        {label}
      </label>
    </div>
  );
};

export default Option;
